import * as DeviceTypes from "../components/devices/_deviceTypes";
interface UpdateAvailable {
  updateAvailable: boolean;
  updateStatus: string;
  version: string | null;
  nextVersion: string | null;
}

export const updateDeviceAvailable = (
  device: any = {},
  deviceType = DeviceTypes.TAPLIFE_CONTROLLER
) => {
  var updateDetail: UpdateAvailable = {
    updateAvailable: false,
    updateStatus: "",
    version: null,
    nextVersion: null,
  };
  switch (device?.deviceType) {
    case DeviceTypes.TAPLIFE_CONTROLLER:
      const { updateAvailable, updateStatus, version, nextVersion } = device;
      return (updateDetail = {
        updateAvailable,
        updateStatus,
        version,
        nextVersion,
      });
      break;
    default:
      return null;
      break;
  }
  //   return null;
};
